import { OrganisationDetailsEnum } from "./organizationDetails.constants";

export const ProductParams = [
    OrganisationDetailsEnum.SORT_BY,
    OrganisationDetailsEnum.SORT_DIR,
    OrganisationDetailsEnum.SEARCH,
    OrganisationDetailsEnum.PAGE,
]